module.exports = __webpack_public_path__ + "static/media/Diamant_1.112e16b6.svg";